import Component from './Component';
import 'select2';
import axios from 'axios';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 let dropdown1;
 let dropdown2;
 const a = new RegExp(`/${window.location.host}/`);



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */








/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class QuickStart extends Component {

    decorator () {
        return {
            selector : '.js-quick-start',
            name : 'QuickStart',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        // BIND ELEMENTS
        this.bindElements();
    }


    cacheElements () {
        this.container = this.element.querySelector('.js-qs-container');
        this.dropdown1 = this.$element.find('.js-qs-dropdown1');
        this.dropdown2 = this.$element.find('.js-qs-dropdown2');
        this.second = this.element.querySelector('.js-qs-second');
        this.secondText = this.second.querySelector('.js-qs-second-text');
        this.button = this.element.querySelector('.js-qs-btn');
    }


    bindElements () {
        // Make a new request
        const newAxios = axios.get('/quickstart/questions/json')
            .then(response => {

                // Map obj.question to map.text
                const _data = $.map(response.data, obj => {
                    obj.text = obj.question;
                    return obj;
                });

                return _data;
            })
            .then(data => {
                const _theme = this.dropdown1.data('dropdown-theme');

                // Initialize 1st Dropdown
                // And pass the data
                dropdown1 = this.dropdown1.select2({
                    theme: _theme || 'default',
                    width: 'resolve',
                    dropdownParent: this.dropdown1.parent(),
                    data: data,
                    templateResult: (data, container) => {
                        if (data.element) {
                            container.classList.add(data.element.getAttribute('class'));
                        }

                        return data.text;
                    }
                });

                this.dropdownEvents(dropdown1);

                // Make a request for the 2nd dropdown
                this.requestAjax(dropdown1, data);

                return data;
            })
            .then(data => {
                // Set a default value of the dropdown
                dropdown1.val(data[0].id).trigger('change');
            })
            .catch(error => {
                console.error(error);
            });

        return newAxios;
    }


    requestAjax (dropdown, data) {
        dropdown.on('change', e => {
            const _id = dropdown.val();

            // Change follow up text
            // If no child set a[href] link
            data.forEach(item => {

                if (item.id == parseInt(_id)) {
                    this.secondText.innerHTML = item.followup_text || '&nbsp;&nbsp;';
                    if (item.link_url != '') {
                        this.button.setAttribute('href', item.link_url);
                    }

                    if (!a.test(this.button.href)) {
                        this.button.setAttribute('target', '_blank');
                    } else {
                        this.button.removeAttribute('target');
                    }
                }
            });


            // Make a request for a given ID
            const showData = axios.get(`/quickstart/questions/json/${_id}`)
                .then(response => {
                    if (response.data.length < 1 || response.status != 200) { return; }

                    // Map obj.question to obj.text
                    const _data = $.map(response.data, obj => {
                        obj.text = obj.question;
                        return obj;
                    });

                    // this.second.classList.add('is-hidden');

                    return _data;
                })
                .then(data => {

                    this.second.classList.add('is-hidden');
                    if (!data) { return data; }

                    // Clear dropdown
                    if (typeof dropdown2 === 'object') { dropdown2.empty(); }

                    const _theme = this.dropdown2.data('dropdown-theme');

                    this.second.classList.remove('is-hidden');

                    // Initialize 2nd dropdown
                    // And pass the data
                    dropdown2 = this.dropdown2.select2({
                        theme: _theme || 'default',
                        width: 'resolve',
                        dropdownParent: this.dropdown2.parent(),
                        data: data,
                        templateResult: (data, container) => {
                            if (data.element) {
                                container.classList.add(data.element.getAttribute('class'));
                            }

                            return data.text;
                        }
                    });

                    this.dropdownEvents(dropdown2);

                    // Watch the changes of the 2nd dropdown
                    this.changeSecondDropdown(dropdown2, data);

                    return data;
                })
                .then(data => {
                    if (!data) { return; }
                    // Dropdown, select first item as a default value
                    dropdown2.val(data[0].id).trigger('change');

                    // When data is rendered successfully
                    // Show quickstart
                    this.toggleDisplay();
                })
                .catch(error => {
                    console.error(error);
                })

            return showData;
        })
    }


    changeSecondDropdown (dropdown, data) {
        dropdown.on('change', e => {
            const _id = dropdown.val();

            data.forEach(item => {
                if (item.id == parseInt(_id)) {
                    this.button.setAttribute('href', item.link_url);

                    if (!a.test(this.button.href)) {
                        this.button.setAttribute('target', '_blank');
                    } else {
                        this.button.removeAttribute('target');
                    }
                }
            });
        });
    }


    toggleSecondItem () {
        this.second.classList.add('is-hidden');
    }


    toggleDisplay () {
        if (!this.container.classList.contains('is-show')) {
            this.container.classList.add('is-show');
        } else {
            this.container.classList.remove('is-hidden');
        }
    }

    dropdownEvents (dropdown) {

        dropdown.on('select2:open', e => {
            let _obj = {
                parent: e.target.parentElement.querySelector('.select2-dropdown'),
                results: e.target.parentElement.querySelector('.select2-results'),
                options: e.target.parentElement.querySelector('.select2-results__options')
            }

            e.target.parentElement.classList.add('is-active');

            if (e.target.length < 9) { return; }

            this.addScrollbar(_obj);
        });


        dropdown.on('select2:close', e => {
            e.target.parentElement.classList.remove('is-active');
        });
    }


    addScrollbar (_obj) {

        const upArrow = `
            <a href="javascript:;" class="select2-dropdown-scroll up">
                <span class="o-icon">
                    <svg><use xlink:href="#caret-up"></use></svg>
                </span>
            </a>
        `;

        const downArrow = `
            <a href="javascript:;" class="select2-dropdown-scroll down">
                <span class="o-icon">
                    <svg><use xlink:href="#caret-down"></use></svg>
                </span>
            </a>
        `;

        _obj.parent.classList.add('has-scrolling');

        _obj.parent.insertAdjacentHTML('afterbegin', upArrow);
        _obj.parent.insertAdjacentHTML('beforeend', downArrow);

    }


    removeScrollbar (_obj) {
        _obj.parent.classList.remove('has-scrolling');
        _obj.parent.querySelector('.select2-dropdown-scroll').remove();
    }


}
